import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import MoveToInboxRoundedIcon from '@material-ui/icons/MoveToInboxRounded';
import MapRoundedIcon from '@material-ui/icons/MapRounded';
import PlaylistAddCheckRoundedIcon from '@material-ui/icons/PlaylistAddCheckRounded';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import VpnKeyRoundedIcon from '@material-ui/icons/VpnKeyRounded';
import HelpRoundedIcon from '@material-ui/icons/HelpRounded';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import { verifyLogin } from '../../helpers';
import HelpBanner from '../HelpBanner/HelpBanner';
import Loading from '../loading/loading';

const Logo = require('../../assets/images/logo.png').default;

const EXPANDED_WIDTH = 248;
const COLLAPSED_WIDTH = 76;
const STORAGE_KEY = 'bez_nav_collapsed';

// Primary navigation (loan-related dashboard screens).
const NAV_ITEMS = [
  { label: 'Home', path: '/home', Icon: HomeRoundedIcon },
  { label: 'Loans', path: '/customers-accounts', Icon: AccountBalanceRoundedIcon },
  { label: 'Requests', path: '/request', Icon: MoveToInboxRoundedIcon },
  { label: 'Maps', path: '/loan-map', Icon: MapRoundedIcon },
  { label: 'Loan Tasks', path: '/loan-tasks', Icon: PlaylistAddCheckRoundedIcon },
];

const styles = () => ({
  sidebar: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(180deg, #2E3B6E 0%, #1B2547 100%)',
    color: '#E8ECF6',
    boxShadow: '2px 0 12px rgba(16, 36, 70, 0.18)',
    zIndex: 1200,
    overflowX: 'hidden',
    transition: 'width 0.2s ease',
  },
  expanded: { width: EXPANDED_WIDTH },
  collapsed: { width: COLLAPSED_WIDTH },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 64,
    padding: '0 12px 0 18px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    flexShrink: 0,
  },
  brandWrap: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    overflow: 'hidden',
  },
  logo: {
    height: 28,
    width: 28,
    flexShrink: 0,
    filter: 'brightness(0) invert(1)',
  },
  brandText: {
    marginLeft: 12,
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: 0.4,
    whiteSpace: 'nowrap',
    color: '#ffffff',
  },
  toggleBtn: {
    color: '#C7D0E8',
    padding: 6,
  },
  nav: {
    listStyle: 'none',
    margin: 0,
    padding: '10px 0',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    height: 46,
    margin: '2px 10px',
    padding: '0 16px',
    borderRadius: 10,
    color: '#C7D0E8',
    textDecoration: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background 0.15s ease, color 0.15s ease',
    '&:hover': {
      background: 'rgba(255,255,255,0.08)',
      color: '#ffffff',
    },
  },
  navItemActive: {
    background: 'rgba(69, 130, 255, 0.20)',
    color: '#ffffff',
    boxShadow: 'inset 3px 0 0 #4582FF',
  },
  navIcon: {
    minWidth: 28,
    display: 'flex',
    alignItems: 'center',
    fontSize: 22,
  },
  navLabel: {
    marginLeft: 14,
    fontSize: 14,
    fontWeight: 400,
    overflow: 'hidden',
  },
  collapsedItem: {
    justifyContent: 'center',
    padding: 0,
  },
  footer: {
    borderTop: '1px solid rgba(255,255,255,0.08)',
    padding: '8px 0 14px',
    flexShrink: 0,
  },
  userRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 20px 6px',
    color: '#9AA6C6',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
});

class navbar extends Component {
  constructor(props) {
    super(props);
    let collapsed = false;
    try {
      collapsed = localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) { collapsed = false; }
    this.state = {
      result: false,
      userName: '',
      userRoleId: null,
      collapsed,
    };
  }

  componentDidMount() {
    const { user } = verifyLogin();
    this.setState({
      userName: user.firstName,
      userRoleId: user.userRoleId,
    });
    this.applyBodyClass();
  }

  componentWillUnmount() {
    // Intentionally leave the body offset class in place so navigating
    // between authenticated screens does not flicker. A full reload on
    // logout/login clears it.
  }

  toggleCollapse = () => {
    this.setState(
      (prev) => ({ collapsed: !prev.collapsed }),
      () => {
        try { localStorage.setItem(STORAGE_KEY, this.state.collapsed ? '1' : '0'); } catch (e) { /* no-op */ }
        this.applyBodyClass();
      },
    );
  };

  handleLogout = (key) => {
    key.preventDefault();
    this.setState({ result: true });
    localStorage.removeItem('data');
    setTimeout(() => { window.location.replace('/'); }, 800);
  };

  // Renders an icon+label row; wraps in a right-side Tooltip when collapsed.
  row = (key, {
    Icon, label, active, href, onClick,
  }) => {
    const { classes } = this.props;
    const { collapsed } = this.state;
    const content = (
      <a
        key={key}
        href={href}
        onClick={onClick}
        className={`${classes.navItem} ${active ? classes.navItemActive : ''} ${collapsed ? classes.collapsedItem : ''}`}
      >
        <span className={classes.navIcon}><Icon fontSize='small' /></span>
        {!collapsed && <span className={classes.navLabel}>{label}</span>}
      </a>
    );
    if (collapsed) {
      return (
        <Tooltip key={key} title={label} placement='right' arrow>
          {content}
        </Tooltip>
      );
    }
    return content;
  };

  applyBodyClass() {
    const { collapsed } = this.state;
    try {
      document.body.classList.toggle('bez-nav-collapsed', collapsed);
      document.body.classList.toggle('bez-nav-expanded', !collapsed);
    } catch (e) { /* no-op */ }
  }

  render() {
    const { classes } = this.props;
    const {
      result, userName, userRoleId, collapsed,
    } = this.state;
    const currentPath = this.props.MainProps
      && this.props.MainProps.match
      ? this.props.MainProps.match.path
      : '';
    const isAdmin = userRoleId === 1 || userRoleId === 2;

    return (
      <>
        {result === true ? <Loading MainProps={this.props.MainProps} /> : null}
        <HelpBanner path={currentPath} />
        <nav className={`${classes.sidebar} ${collapsed ? classes.collapsed : classes.expanded}`}>
          <div className={classes.header}>
            {!collapsed && (
              <div className={classes.brandWrap}>
                <img className={classes.logo} src={Logo} alt='BrickEZ' />
                <span className={classes.brandText}>BrickEZ</span>
              </div>
            )}
            <Tooltip title={collapsed ? 'Expand' : 'Collapse'} placement='right' arrow>
              <IconButton className={classes.toggleBtn} onClick={this.toggleCollapse} size='small'>
                {collapsed ? <MenuRoundedIcon /> : <ChevronLeftRoundedIcon />}
              </IconButton>
            </Tooltip>
          </div>

          <div className={classes.nav}>
            {NAV_ITEMS.map((item) => this.row(item.path, {
              Icon: item.Icon,
              label: item.label,
              href: item.path,
              active: currentPath === item.path,
            }))}
          </div>

          <div className={classes.footer}>
            {!collapsed && userName ? (
              <div className={classes.userRow}>{userName}</div>
            ) : null}

            {this.row('profile', {
              Icon: AccountCircleRoundedIcon,
              label: 'Profile',
              href: '/profile',
              active: currentPath === '/profile',
            })}

            {isAdmin && this.row('admin', {
              Icon: VpnKeyRoundedIcon,
              label: 'Admin',
              href: '/admin',
              active: currentPath === '/admin',
            })}

            {this.row('help', {
              Icon: HelpRoundedIcon,
              label: 'Help',
              href: '/help',
              active: currentPath.startsWith('/help'),
            })}

            {this.row('logout', {
              Icon: ExitToAppRoundedIcon,
              label: 'Logout',
              href: '/',
              onClick: this.handleLogout,
            })}
          </div>
        </nav>
      </>
    );
  }
}

export default withStyles(styles)(navbar);
